export const FETCH_OWNERS = 'SaleTypes/FETCH_OWNERS'
export const FETCH_OWNERS_SUCCESS = 'SaleTypes/FETCH_OWNERS_SUCCESS'
export const FETCH_OWNERS_ERROR = 'SaleTypes/FETCH_OWNERS_ERROR'
export const FETCH_OWNERS_DONE = 'SaleTypes/FETCH_OWNERS_DONE'
